import { GUARANTEEDJOBS_LINK, POSTAD_PAGE_LINK, RECRUITMENT_ASSIST_LINK, CANDIATE_TEST_PAGE_LINK } from './pageLinks';

/**
 * URL/Search Constants
 */

export const HOME_PATH_REGEX = '/jobs';
export const GUARANTEEDJOBS_PATH_REGEX = GUARANTEEDJOBS_LINK;
export const RECRUITMENT_ASSIST_LINK_PATH_REGEX = RECRUITMENT_ASSIST_LINK;
export const POSTADJOBS_REF_PATH_REGEX = '/jobs/post-ad-jobs-ref';
export const VAP_PATH_REGEX = '/jobs/:title([a-zA-Z0-9.\\-]+)W0QQAdIdZ:id([a-zA-Z0-9]+)(.*)';
// export const VAP_PATH_REGEX = '/jobs/:title([a-zA-Z0-9.\\-]+)W0QQAdIdZ:id([a-zA-Z0-9]+):queryParams?';
export const SNB_PATH_REGEX = '/jobs/:query+(zwqxj)+:identifier';
export const POST_AD_S1_PATH_REGEX = POSTAD_PAGE_LINK;
export const SIGN_IN_PAGE = '/SignIn?redirect={redirect}';
export const KOTAK_PROMO_DAILER = '//www.quikr.com/jobs/pushToDailerForKotak';
export const PREMIUM_APPLY_RENEWAL = '/vip-apply-renewal';
export const STORE_RESPONSE_URL = '/storeCandidateResponse';
export const CANDIDATE_TEST_LINK_PATH_REGEX = CANDIATE_TEST_PAGE_LINK;

export const GET_RECRUITER_CONTACT_DETAILS = '/jobs/getRecruiterDetails';
export const CALL_UNLOCK_PAYMENT = '/jobs/candidate-call-unlock-payment?packId={packId}&adId={adId}';
export const JOBS_404 = '/jobs/404';
export const FLEXI_CANDIDATE_REGISTER = '/jobs/flexi/register';
export const FLEXI_CANDIDATE_PROFILE = '/jobs/flexi/candidate/profile/:mobile';
export const FLEXI_CANDIDATE_RMT_DATA_CAPTURE = '/jobs/flexi/rmt-data-capture';
export const FLEXI_RECRUITER_RMT_REPORT = '/jobs/flexi/rmt/report';
export const UPGRADE_AD = '/jobs/upgrade-ad';

export const URL_IDENTIFIERS = {
	// 'keyword-city': '1226783897',
	//  keyword: '1519612219',
	// 'role-city': '284607247',
	// 'type-role': '57998541',
	'keyword': '1519612219',
	'keyword-city': '1226783897',

	'indexedKeyword': '2726005330',
	'indexedKeyword-city': '4157493934',

	'type-keyword': '1516423419',
	'type-keyword-city': '1953942709',
	'locality-city': '3126537171',
	'role': '1466534506',
	'role-city': '284607247',
	'role-locality-city': '3333399006',
	'role-subrole': '14665345061',
	'role-subrole-city': '2846072472',
	'role-subrole-locality-city': '33333990063',
	'type': '2363381545',
	'type-city': '2034660499',
	'type-locality-city': '3250055950',
	'type-role': '57998541',
	'type-role-city': '1452070842',
	'type-role-locality-city': '2914287049',
	'type-role-subrole': '579985411',
	'type-role-subrole-city': '14520708422',
	'type-role-subrole-locality-city': '29142870493',
	'city': '760939060',
	'salary-city': '447231107',
	'salary-locality-city': '3701154297',
	'role-salary': '1153604546',
	'role-salary-city': '3767432033',
	'role-salary-locality-city': '2654641726',
	'role-salary-subrole': '11536045461',
	'role-salary-subrole-city': '37674320332',
	'role-salary-subrole-locality-city': '26546417263',
	'type-salary-city': '2579561593',
	'type-salary-locality-city': '1451053195',
	'type-role-salary': '3349828408',
	'type-role-salary-city': '127511652',
	'type-role-salary-locality-city': '2728933051',
	'type-role-salary-subrole': '33498284081',
	'type-role-salary-subrole-city': '1275116522',
	'type-role-salary-subrole-locality-city': '27289330513',
	'experience-city': '3467090630',
	'experience-locality-city': '1453635856',
	'role-experience': '753549341',
	'role-experience-city': '1504841750',
	'role-experience-locality-city': '1559395222',
	'role-subrole-experience': '7535493411',
	'role-subrole-experience-city': '15048417502',
	'role-subrole-experience-locality-city': '15593952223',
	'type-experience-city': '1632999624',
	'type-experience-locality-city': '3353931060',
	'type-role-experience': '2199405075',
	'type-role-salary-subrole-locality-city': '3545522532',
	'type-role-experience-locality-city': '1023845720',
	'type-role-subrole-experience': '21994050751',
	'type-role-subrole-experience-city': '35455225322',
	'type-role-subrole-experience-locality-city': '10238457203',
	'education-city': '2380404578',
	'education-locality-city': '1558281504',
	'role-education': '2017646763',
	'role-education-city': '1253134185',
	'role-education-locality-city': '177069230',
	'type-education-city': '1979405771',
	'type-education-locality-city': '1960431214',
	'type-role-education': '2153486850',
	'type-role-education-city': '3372863858',
	'type-role-education-locality-city': '2511126896',
	'salary-experience-city': '4253656706',
	'salary-experience-locality-city': '2348176638',
	'role-salary-experience': '1006492479',
	'role-salary-experience-city': '1643533206',
	'role-salary-experience-locality-city': '3841912454',
	'type-salary-experience-city': '3347216058',
	'type-salary-experience-locality-city': '3219402777',
	'type-role-salary-experience': '32901895',
	'type-role-salary-experience-city': '4279183568',
	'type-role-salary-experience-locality-city': '1858474484',
	'salary-education-city': '2697180687',
	'salary-education-locality-city': '57694799',
	'role-salary-education': '3630676277',
	'role-salary-education-city': '3593472971',
	'role-salary-education-locality-city': '3149775769',
	'type-salary-education-city': '507658350',
	'type-salary-education-locality-city': '2144157990',
	'type-role-salary-education': '1726369620',
	'type-role-salary-education-city': '1272901324',
	'type-role-salary-education-locality-city': '3867893122',
	'experience-education-city': '1922700911',
	'experience-education-locality-city': '3376507071',
	'role-experience-education': '1927661940',
	'role-experience-education-city': '3234096138',
	'role-experience-education-locality-city': '2203230008',
	'type-salary-education-city': '1309196010',
	'type-experience-education-locality-city': '2546233669',
	'type-role-experience-education': '1316446705',
	'type-role-experience-education-city': '3162079075',
	'type-role-experience-education-locality-city': '1862362720',
	'salary-experience-education-locality-city': '4127499775',
	'role-salary-experience-education': '2777308168',
	'role-salary-experience-education-city': '4152718827',
	'role-salary-experience-education-locality-city': '1623919913',
	'type-salary-experience-education-city': '1726163047',
	'type-salary-experience-education-locality-city': '1074254920',
	'type-role-salary-experience-education': '2614114743',
	'type-role-salary-experience-education-city': '1225022724',
	'type-role-salary-experience-education-locality-city': '2708908467',
	'type-salary': '3425898827',
	'type-education': '2641381991',
	'type-experience-city': '3202219028',
	'type-salary-experience': '3341090907',
	'type-salary-education': '3107234158',
	'type-experience-education': '3623873606',
	'type-salary-experience-education': '2649889506',
	'salary': '2484321137',
	'salary-experience': '3081298699',
	'salary-education': '1579384427',
	'salary-experience-education': '51077540',
	'experience': '93372675',
	'experience-education': '1561959732',
	'education': '3674889938',
	'role-company': '487012953',
	'role-company-city': '2748976742',
	'salary-experience-education-city': '1488539096',
	'companyJobs': '487012822'
};

export const SNB_URL_STRING = 'zwqxj';

export const URL_PATTERN = /[^A-Z0-9_]+/ig;
export const SANITIZE_URL_SEPERATOR = '-';
export const ARRAY_SEPERATOR = '_';
export const PARAMETER_SEPERATOR = '+';

export const GET_PARAMS = [
  'sort',
  'company'
];

export const KEYWORD_URL_PARAMS = [
  'keyword',
  'type',
  'city'
];

export const URL_PARAMS_ORDER = [
  'type',
  'role',
  'keyword',
  'indexedKeyword',
  'salary',
  'subrole',
  'experience',
  'education',
  'locality',
  'city',
  'company'
];

export const NO_INDEX_URL_IDENTIFIERS = [
	'1519612219',
	'1226783897',
	//'2726005330',
	//'4157493934',
	'1516423419',
	'1953942709',
	//'487012822',
];

export const SEARCH_URL_IDENTIFIERS = [
	'1519612219',
	'1226783897',
	'2726005330',
	'4157493934',
	'1516423419',
	'1953942709',
	'487012822'
];

export const NOODP_STRING = 'noodp';

export const NO_INDEX_STRING = 'noindex';



// WEBPACK FOOTER //
// ../q-jobs/src/constants/url.js